import React, { useCallback } from 'react'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import EmptyLink from 'components/EmptyLink'
import { TOneItemCallback } from 'HttpRequests'
import { IProductBase, IProductInCart } from 'product/IProduct'
import QuantitySelect from 'product/QuantitySelect'
import { Col } from 'react-bootstrap'

interface ICartProductActionsProps {
  product: IProductInCart
  isLoading: boolean
  onRemoveProduct: TOneItemCallback<IProductBase>
  onChangeProductQuantity: (product: IProductBase, quantity: number) => void
}

const CartProductActions: React.FC<ICartProductActionsProps> = ({
  product,
  isLoading,
  onRemoveProduct,
  onChangeProductQuantity,
}) => {
  const handleChangeProductOrder = useCallback(
    (newQuantity) => {
      onChangeProductQuantity(product, newQuantity)
    },
    [product, onChangeProductQuantity]
  )

  const handleRemove = useCallback(() => {
    onRemoveProduct(product)
  }, [product, onRemoveProduct])

  return (
    <>
      {product.left_quantity > 0 ? (
        <>
          <Col xs={6}>
            <QuantitySelect
              quantity={product.quantity}
              maxQuantity={product.left_quantity}
              isLoading={isLoading}
              onChange={handleChangeProductOrder}
            />
          </Col>
          <Col xs={4}>
            <div className='big-font'>{product.quantity * product.price}&nbsp;₽</div>
          </Col>
          <Col xs={2}>
            <EmptyLink onClick={handleRemove}>
              <FontAwesomeIcon icon={faTrashAlt} color='var(--color-grey)' />
            </EmptyLink>
          </Col>
        </>
      ) : (
        <>
          <Col xs={10}>
            <div className='big-font'>Отсутствует в офисе</div>
          </Col>
          <Col xs={2}>
            <EmptyLink onClick={handleRemove}>
              <FontAwesomeIcon icon={faTrashAlt} color='var(--color-grey)' />
            </EmptyLink>
          </Col>
        </>
      )}
    </>
  )
}
export default CartProductActions
